import { createSlice } from "@reduxjs/toolkit";

export const UI_PREFS_CACHE_KEY = "uiPrefs";

// Seeded from localStorage so the first paint of any IntentsTable already uses
// the user's layout. Without it the table renders the org default and visibly
// snaps when the fetch lands -- and three of the six call sites render several
// tables at once.
const seed = () => {
  try {
    return JSON.parse(localStorage.getItem(UI_PREFS_CACHE_KEY) || "{}");
  } catch (e) {
    return {};
  }
};

export const initialState = {
  loaded: false,
  prefs: seed(),
};

const UiPrefsSlice = createSlice({
  name: "UiPrefs",
  initialState,
  reducers: {
    recieveUiPrefs(state, action) {
      state.prefs = action.payload;
      state.loaded = true;
    },
    // Optimistic: applied before the PATCH so every mounted table reorders on
    // the same frame as the click.
    setIntentsColumnPrefsLocal(state, action) {
      state.prefs = { ...state.prefs, intents_columns: action.payload };
    },
  },
});

export const { recieveUiPrefs, setIntentsColumnPrefsLocal } = UiPrefsSlice.actions;

export default UiPrefsSlice.reducer;
